import { useState, useEffect } from 'react';
import { loadDemoStatuses } from '../demo/demoData';

function useCveStatuses() {
  const [cveStatuses, setCveStatuses] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchStatuses = async () => {
    try {
      const data = await loadDemoStatuses('cves');
      setCveStatuses(data || {});
    } catch (err) {
      setError('Failed to fetch cve statuses: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatuses();
  }, []);

  const updateStatus = async (cveName, enabled) => {
    setLoading(true);
    try {
      setCveStatuses(prev => ({
        ...prev,
        [cveName]: { ...(prev[cveName] || {}), enabled }
      }));
      return true;
    } catch (err) {
      setError(`Failed to ${enabled ? 'enable' : 'disable'} ${cveName}: ${err.message}`);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { 
    cveStatuses,
    loading, 
    error, 
    updateStatus,
    refreshStatuses: fetchStatuses 
  };
}

export default useCveStatuses; 